import { apiClient } from "@/modules/apiClient";
import { AxiosResponse } from "axios";
import { MembershipsDto } from "@/models/memberships/MembershipsDto";

export const MembershipsService = {
	list(): Promise<AxiosResponse<MembershipsDto>> {
		return apiClient.get("/memberships");
	},
	async listQuery(): Promise<MembershipsDto> {
		const response = await apiClient.get(`/memberships`);
		return response.data;
	},
};
